// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/plan_recurrence_kind.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/plan_recurrence_kind.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_plan_recurrence_kind = /*@__PURE__*/
  fileDesc("CkJzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvcGxhbl9yZWN1cnJlbmNlX2tpbmQucHJvdG8SJ3N0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcypcChJQbGFuUmVjdXJyZW5jZUtpbmQSGQoVUExBTl9LSU5EX1VOU1BFQ0lGSUVEEAASFQoRUExBTl9LSU5EX01PTlRITFkQARIUChBQTEFOX0tJTkRfWUVBUkxZEAJCL6oCLFN0dWR5by5Ub2RheS5TdWJzY3JpcHRpb25zLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.PlanRecurrenceKind.
 */
export const PlanRecurrenceKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_plan_recurrence_kind, 0);

/**
 * The kind of recurrence of subscription plan.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.PlanRecurrenceKind
 */
export const PlanRecurrenceKind = /*@__PURE__*/
  tsEnum(PlanRecurrenceKindSchema);

